export default "__VITE_ASSET__BhDkIhqK__"